var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"div"},[_c('div',{staticStyle:{},attrs:{"id":"header-box"}},[_c('div',{attrs:{"id":"logo-box"}},[_c('img',{staticClass:"logo",attrs:{"src":require("../assets/car-logo.png"),"alt":""}})])])])
}]

export { render, staticRenderFns }